import { formatDate } from '@blimo/shared';
import { Badge } from '@blimo/ui';

/**
 * Befristeter Zugang (F-005): Datum + Hinweis. Ob abgelaufen bzw. bald ablaufend, entscheidet die API (`access_state`).
 * @param {{ user: { access_expires_at?: string|null, access_state?: 'expired'|'expiring'|'limited'|null } }} props
 */
export function AccessExpiry({ user }) {
  if (!user.access_expires_at) return <span className="text-muted-foreground">unbefristet</span>;
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      <span className="numeric">{formatDate(user.access_expires_at)}</span>
      {user.access_state === 'expired' && <Badge variant="destructive">Abgelaufen</Badge>}
      {user.access_state === 'expiring' && <Badge variant="warning">Läuft bald ab</Badge>}
    </span>
  );
}
